import React from 'react'
import ReportHubCustPhonePage from "./ReportHubCustPhonePage"

function ReportHubCustPhoneContainer(props) {
    const {location} = props
    const {search} = location
    const params = search ? Object.fromEntries(new URLSearchParams(search)) : ""
    const custId = params?.custId || ''
    const custName = params?.custName || ''

    return (
        <div className="ReportByDayContainer">
            <ReportHubCustPhonePage custId={custId} custName={custName}/>
        </div>
    )
}

export default ReportHubCustPhoneContainer
